import styled from 'styled-components';

import { mediaConfined, mediaXWide } from '@xing-com/layout-tokens';
import {
  space3XL,
  space4XL,
  space5XL,
  spaceL,
  spaceXL,
} from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';

export const IndustriesSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${space3XL};

  @media ${mediaConfined} {
    margin-bottom: ${space4XL};
  }
  @media ${mediaXWide} {
    margin-bottom: ${space5XL};
  }
`;
export const GridIndustries = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: ${spaceL};

  @media ${mediaConfined} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media ${mediaXWide} {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
`;
export const IndustrySectionHeadline = styled(Headline)`
  margin-bottom: ${spaceL};

  @media ${mediaConfined} {
    margin-bottom: ${spaceXL};
  }
  @media ${mediaXWide} {
    margin-bottom: ${spaceXL};
  }
`;
export const CompanyCardsHeadline = styled(Headline)`
  margin-bottom: ${spaceL};

  @media ${mediaConfined} {
    margin-bottom: ${spaceXL};
  }
  @media ${mediaXWide} {
    margin-bottom: ${spaceXL};
  }
`;
